import React from "react";
import { Collapse, Divider, List, ListItem, ListItemButton, ListItemIcon, ListItemText, keyframes } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";

import { useLoading } from "../../../util/LoadingContext";
import VerticalMenuPageSolicitacoes from "./VerticalMenuPageSolicitacoes";
import { useProfile } from "../../common/useProfile";

export default function VerticalMenuPage(props) {
    const { menu } = props;
    const prof = useProfile();
    return (
        <List>
            {menu.map((row, index) => {

                // console.log( row.rule )
                if( row.rule && row.rule.length > 0 ){
                    
                    if( !prof.temAcesso( row.rule)) return;
                }
                if (row.nome === 'Divider') {
                    return (
                        <Divider key={index} />
                    )
                }
                if (row.api.length > 0) {
                    return (
                        <VerticalMenuPageSolicitacoes key={index} menu={row} />                    
                    )
                }
                
                return (
                    <ListItem disablePadding key={index}>
                        <ListItemButton href={row.href} >
                            <ListItemIcon>
                                <div style={{width:24, height:24}}
                                    dangerouslySetInnerHTML={{ __html: row.icone }}
                                />
                            </ListItemIcon>
                            <ListItemText primary={row.nome} />
                        </ListItemButton>
                    </ListItem>
                )
            }
            )}
        </List>
    )
}